const SEARCH_ERROR_MESSAGES: Record<string, string> = {
  'Search term contains invalid characters': 'Søket inneholder ugyldige tegn',
  'Invalid search term': 'Ugyldig søkeord',
  'Invalid GlobalSearch format': 'Ugyldig søkeformat',
  'Invalid JSON format in GlobalSearch': 'Ugyldig søkeformat',
  'Invalid search parameters': 'Ugyldige søkeparametere',
}

export function getSearchErrorMessage(serverMessage?: string): string {
  if (!serverMessage) {
    return 'Søket feilet'
  }
  return SEARCH_ERROR_MESSAGES[serverMessage] || 'Søket inneholder ugyldige tegn'
}
